import api from './api';

export interface CodigoServico {
  id: number;
  codigoAtividade: string;
  codigoServico: string;
  descricao: string;
  tipo?: string | null;
  ativo: boolean;
}

export interface CreateCodigoServicoDto {
  codigoAtividade: string;
  codigoServico: string;
  descricao: string;
  tipo?: string;
  ativo?: boolean;
}

export interface UpdateCodigoServicoDto {
  codigoAtividade?: string;
  codigoServico?: string;
  descricao?: string;
  tipo?: string;
  ativo?: boolean;
}

export const codigosServicoService = {
  async list(): Promise<CodigoServico[]> {
    const { data } = await api.get('/codigos-servico');
    return data;
  },

  async create(dto: CreateCodigoServicoDto): Promise<CodigoServico> {
    const { data } = await api.post('/codigos-servico', dto);
    return data;
  },

  async update(id: number, dto: UpdateCodigoServicoDto): Promise<CodigoServico> {
    const { data } = await api.patch(`/codigos-servico/${id}`, dto);
    return data;
  },

  async remove(id: number): Promise<{ success: boolean }> {
    const { data } = await api.delete(`/codigos-servico/${id}`);
    return data;
  },
};

